<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>

<div class="body-top d-flex justify-content-between mb-15">
  <a [attr.href]="service.getImportExampleFileUrl()" class="left-text text-neutral-n9"><span class="icon-export me-2"></span>Download example file</a>
  <span class="right-text">Max Rows: {{ MAX_ROWS }}</span>
</div>

<div>
  <div class="form-group">
    <input-file (change)="onChangeImportFile($event)" [accept]="accept" [acceptExtensions]="acceptExtensions" [maxSize]="5e+6" [maxFiles]="1"></input-file>
  </div>
  <div *ngIf="isAdmin" class="form-group d-flex mb-10">
    <label class="form-label required">User </label>
    <div style="margin-left: 10px">
      <span (click)="showUserListModal()" class="text-navy editable-text cp">
        <span *ngIf="!selectedUser">Select user</span>
        <span *ngIf="selectedUser">{{ selectedUser.email }} &lt;{{ selectedUser.username }}&gt;</span>
      </span>
    </div>
  </div>
  <div class="error-section" *ngIf="importInfo && status && (status.status === 'SUCCEEDED' || status.status === 'FAILED')">
    <div class="error-note">
      <span class="d-block" *ngIf="importInfo.skipped">Unfortunately, not all the rows could be imported.</span>
      <span class="d-block"><strong>Imported Rows:</strong>{{ importInfo.imported }}</span>
      <span class="d-block"><strong>Skipped Rows:</strong>{{ importInfo.skipped }}</span>
    </div>
  </div>
  <div class="error-section">
    <div class="error-table-wrapper" *ngIf="validationMessages.length">
      <table class="error-table mb-15">
        <thead>
          <tr>
            <th>Row</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let err of validationMessages">
            <td>{{ err.line }}</td>
            <td>{{ err.message }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button (click)="onCancelImport()" class="btn btn-outline-dark">Cancel</button>
      <button (click)="onSubmitImport()" [disabled]="!isValid()" class="btn btn-primary ms-15">
        Confirm
      </button>
    </div>
  </div>
</div>

<ng-template #userListModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Select user</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-users-select [multiple]="false" [roles]="['mainaccount']" (selectUser)="onSelectUser($event)"></app-users-select>
  </div>
</ng-template>
